import { FaRegClock } from 'react-icons/fa';
import { CiCalendar } from "react-icons/ci";
import { CiMapPin } from "react-icons/ci";
import foto1 from '../../images/musico.jpg'


const DetailItem = ({ icon: Icon, text }) => (
  <div className="flex items-center space-x-3 mb-2">
    <Icon className="text-primary w-5 h-5 flex-shrink-0" />
    <p className="text-gray-700 text-base">{text}</p>
  </div>
);

function Card({ src }) {
  return (
    <div className="w-full h-[400px] md:h-[500px] rounded-xl overflow-hidden">
      <iframe
        title="mapa"
        src={src}
        className="w-full h-full border-0"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}


function musicos(){

  return (
    <div className="min-h-screen lg:pt-20 bg-gray-50 font-rubik">
      
      {/* Seção 1: Cabeçalho com Título, Descrição e Imagem */}
      <header className="bg-third pt-10 pb-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:space-x-12 items-center">
          
          {/* Texto de Introdução */}
          <div className="lg:w-1/2 text-white mb-8 lg:mb-0">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight">
              Músicos com <br />Alma Solidária
            </h1>
            <p className="text-lg md:text-xl leading-relaxed">
              Você é apaixonado(a) pela música? Na Associação Keralty, estamos buscando para proporcionar momentos especiais aos nossos pacientes em cuidados paliativos.
            </p>
          </div>
          
          {/* Imagem do Cabeçalho */}
          <div className="lg:w-1/2 rounded-xl overflow-hidden shadow-2xl">
            <img
              src={foto1}
              alt="Músicos interagindo com um paciente, tocando violino"
              className="w-full h-auto object-cover"
              onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/600x400/00B388/ffffff?text=Imagem+N%C3%A3o+Carregada' }}
            />
          </div>
        </div>
      </header>

      {/* Onda musical decorativa */}
      <div className="w-full h-24 bg-gray-50 relative -mt-12 overflow-hidden">
        {/* Usando uma SVG para a onda musical */}
        <svg
          className="absolute bottom-0 w-full h-auto"
          viewBox="0 0 1440 100"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,50 C144,10 288,-10 432,50 C576,110 720,10 864,50 C1008,90 1152,10 1296,50 C1440,90 1440,0 1440,0 L0,0 L0,50 Z"
            fill="#e5e7eb" // bg-gray-200
            transform="translate(0, 50)"
          />
          <path
            d="M0,50 C144,10 288,-10 432,50 C576,110 720,10 864,50 C1008,90 1152,10 1296,50 C1440,90 1440,0 1440,0 L0,0 L0,50 Z"
            fill="#f9fafb" // bg-gray-50
          />
          {/* Adicionando algumas notas musicais no SVG, como na imagem */}
          <g fill="#0072CE"> {/* Cor primary */}
            <path d="M100 40c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 5.52 4.48 10 10 10s10-4.48 10-10zM100 40h-5c-2.76 0-5 2.24-5 5v25c0 2.76 2.24 5 5 5h5v-35z" transform="translate(10,10)" />
            <path d="M250 30c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 5.52 4.48 10 10 10s10-4.48 10-10zM250 30h-5c-2.76 0-5 2.24-5 5v25c0 2.76 2.24 5 5 5h5v-35z" transform="translate(50,5)" />
            <path d="M400 45c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 5.52 4.48 10 10 10s10-4.48 10-10zM400 45h-5c-2.76 0-5 2.24-5 5v25c0 2.76 2.24 5 5 5h5v-35z" transform="translate(100,15)" />
            <path d="M550 35c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 5.52 4.48 10 10 10s10-4.48 10-10zM550 35h-5c-2.76 0-5 2.24-5 5v25c0 2.76 2.24 5 5 5h5v-35z" transform="translate(150,0)" />
          </g>
        </svg>
      </div>


      {/* Seção de Detalhes da Vaga: Horários e Endereço */}
      <section className="py-12 px-4 md:px-8 max-w-7xl mx-auto bg-white shadow-lg rounded-xl -mt-10 relative z-10">
        <h2 className="text-xl font-bold text-gray-800 mb-4">Vaga RECORRENTE</h2>
        <h3 className="text-2xl font-bold text-second mb-6">Horários</h3>
        <p className="text-gray-600 mb-6">
          Leia abaixo as descrições de horários para atuar nessa vaga.
        </p>

        <div className="mb-8">
          <DetailItem icon={CiCalendar} text="À combinar" />
          <DetailItem icon={FaRegClock} text="1 hora semanal" />
        </div>

        <h3 className="text-2xl font-bold text-second mb-6">Endereço da vaga</h3>
        <DetailItem
          icon={CiMapPin}
          text="Rua Denver, 190 - Santa Lúcia, Belo Horizonte - MG, Brasil"
        />

        {/* Mapa do Local */}
        <div className="mt-8 rounded-xl overflow-hidden shadow-md border border-gray-200">
            <Card src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.9191244811336!2d-43.95160522477182!3d-19.96990318142752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa697f13759c0b3%3A0x70615013e45e847e!2sR.%20Denver%2C%20190%20-%20Santa%20L%C3%BAcia%2C%20Belo%20Horizonte%20-%20MG%2C%2030360-630!5e0!3m2!1spt-BR!2sbr!4v1746140390921!5m2!1spt-BR!2sbr' />
        </div>
      </section>

      {/* Seção Final: Chamada para Ação */}
      <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto">
        <div className="bg-primary/5 p-8 rounded-xl border-t-4 border-primary text-gray-700 leading-relaxed">
          <p className="mb-4">
            Se você acredita no poder transformador da música e deseja fazer parte de algo significativo, junte-se a nós.
          </p>
          <p className="mb-4">
            Venha fazer parte da nossa equipe de voluntários e faça uma diferença tangível na vida dos outros. Entre em contato conosco hoje mesmo para saber como você pode ajudar a iluminar o dia de alguém com sua música.
          </p>
        </div>
      </section>

      {/* Footer simples */}
      <footer className="bg-second py-4 text-center text-white text-sm">
        <p>Associação Kerailty Brasil | Músicos com Alma Solidária © 2025</p>
      </footer>
    </div>
  );
};


export default musicos;